module.exports = __webpack_public_path__ + "012cf6a10129e2275d79d6adac7f3b02.woff";


//////////////////
// WEBPACK FOOTER
// ./~/material-design-icons/iconfont/MaterialIcons-Regular.woff
// module id = 255
// module chunks = 0 2